export default __webpack_public_path__ + "static/media/hero-image.b529d045.jpg";